module.exports = __webpack_public_path__ + "img/zcyy.a8137c31.png";